import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { TCompleteConciergeSessionPayload } from '@/services/interviews';

import { notifyMeta } from '@/lib/notify';
import { INTERVIEW_KEYS } from '@/constants/queryKeys';
import { errorUtils } from '@/services/errors';
import { interviewsService } from '@/services/interviews';

const useCompleteConciergeSession = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, Error, TCompleteConciergeSessionPayload>({
    meta: notifyMeta('conciergeSessionComplete'),
    mutationKey: ['interviews', 'concierge-session-complete'],
    mutationFn: async payload => errorUtils.unwrap(await interviewsService.completeConciergeSession(payload)),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: INTERVIEW_KEYS.root });
    },
  });
};

export {
  useCompleteConciergeSession,
};
